import React from "react";
import { TripBudget } from "../types";
import TripEmptyState from "../emptyState";
import { formatMoney, formatTripDateRange } from "../utils";

const TripBudgetSection = ({
  budget,
  fallbackTotal,
}: {
  budget?: TripBudget;
  fallbackTotal?: TripBudget["totalBudget"];
}) => {
  const total = budget?.totalBudget || fallbackTotal;
  const items = budget?.budgetBreakDown || [];
  const hasData = Boolean(total || items.length);

  return (
    <section className="trip-section">
      <div className="trip-section-header">
        <h2 className="trip-section-title">Budget</h2>
        {total ? (
          <span className="trip-completion">
            Total {formatMoney(total)}
          </span>
        ) : null}
      </div>

      {!hasData ? (
        <TripEmptyState message="No budget data available" />
      ) : (
        <>
          {total && !items.length ? (
            <div className="trip-budget-card">
              <div className="trip-budget-card-header">
                <h3 className="trip-budget-category">Total budget</h3>
                <span className="trip-budget-amount">
                  {formatMoney(total)}
                </span>
              </div>
            </div>
          ) : null}

          {items.length > 0 ? (
            <div className="trip-budget-list">
              {items.map((item, index) => (
                <div
                  key={`${item.categoryName}-${index}`}
                  className="trip-budget-card"
                >
                  <div className="trip-budget-card-header">
                    <h3 className="trip-budget-category">
                      {item.categoryName}
                    </h3>
                    <span className="trip-budget-amount">
                      {formatMoney(item.categoryBudget)}
                    </span>
                  </div>
                  {item.splitAmount ? (
                    <p className="trip-budget-split">
                      Split: {formatMoney(item.splitAmount)} / person
                    </p>
                  ) : null}
                  {(item.categoryDetails || []).map((detail, detailIndex) => (
                    <div
                      key={`${detail.name}-${detailIndex}`}
                      className="trip-budget-detail"
                    >
                      <span className="trip-budget-detail-name">
                        {detail.name}
                      </span>
                      {(detail.fromDate || detail.toDate) && (
                        <span className="trip-budget-detail-date">
                          {formatTripDateRange(detail.fromDate, detail.toDate)}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : null}
        </>
      )}
    </section>
  );
};

export default TripBudgetSection;
